<template>
  <el-dialog
        :visible="visible"
        :title="editCategoryInfo ? 'Edit a Category' : 'Create a Category'"
        v-on:close="$emit('update:visible', false)"
        width="570px"
    >
      <div class="modal-body">
        <form action="?" ref="categoryForm">
          <input type="file"
                 class="absolute"
                 ref="selectCategoryImageInput"
                 @change="onCategoryImageChanged">
          <a href="#"
             v-on:click.prevent="$refs.selectCategoryImageInput.click()"
             class="choose-template choose-template-hover mb-6"
             :class="{'choose-template-loading': categoryImageIsLoading, 'choose-template-image-exist': categoryImage}"
          >
            <div v-if="!categoryImage">
              <div>
                <font-awesome-icon :icon="['fas', 'images']"/>
              </div>
              <p>Add a Photo</p>
              <span>To represent this category</span>
            </div>
            <div v-else>
              <img class="choose-template-image" :src="categoryImage" :alt="categoryName">
              <div class="inner-text">
                <div>
                  <font-awesome-icon :icon="['fas', 'images']"/>
                </div>
                <p>Change Photo</p>
                <span>Replace the campaign image</span>
              </div>
            </div>
            <div class="spinner-wrap"><i class="fas fa-spinner fa-spin"></i></div>
          </a>

          <div class="mb-6">
            <div class="mb-2"><label for="category-name">Name</label></div>
            <el-input
                type="text"
                placeholder="Name your category"
                v-model="categoryName"
                id="category-name"
                required
                maxlength="50"
                show-word-limit
            >
            </el-input>
          </div>

          <div class="mb-2"><label for="category-desc">Category Description</label></div>
          <el-input
              type="textarea"
              :rows="4"
              placeholder="(Optional) Enter a brief description of this Campaign Category"
              v-model="categoryDescription"
              id="category-desc"
              maxlength="200"
              show-word-limit
          >
          </el-input>

        </form>
      </div>


      <div slot="footer" class="dialog-footer">
        <div class="flex justify-between">
          <el-button size="medium" @click="$emit('update:visible', false)">Cancel</el-button>

          <el-button v-on:click="saveCategory"
                     :disabled="!categoryName"
                     type="primary"
                     size="medium"
          >{{ editCategoryInfo ? 'Save Category' : 'Create Category' }}
          </el-button>
        </div>
      </div>

    </el-dialog>
</template>

<script>
import {createCategory, editCategory, globalImageUploader} from "@/utils/api";

export default {
  name: "create-category-modal",
  props: {
    editCategoryInfo: null,
    visible: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    if (this.editCategoryInfo) {
      this.categoryName = this.editCategoryInfo.name;
      this.categoryDescription = this.editCategoryInfo.description;
      this.categoryImage = this.editCategoryInfo.image;
    }
  },
  methods: {
    saveCategory() {
      if(!this.$refs.categoryForm.checkValidity()) {
        return false;
      }
      if (this.editCategoryInfo) {
        editCategory(this.editCategoryInfo.id, {
          description: this.categoryDescription,
          name: this.categoryName,
          image: this.categoryImage ? this.categoryImage : '',
        }).then(res => {
          this.$message('Category updated');
          this.$emit('done', res);
        }).catch(err => alert(err.error || 'An error has occurred, please try again.'));
      } else {
        createCategory(this.categoryName, this.categoryDescription, this.categoryImage).then(res => {
          this.$message('Category created');
          this.$emit('done', res);
        }).catch(err => alert(err.error || 'An error has occurred, please try again.'))
      }
    },
    onCategoryImageChanged(e) {
      const file = e.target.files[0];
      if (file) {
        this.categoryImageIsLoading = true;
        globalImageUploader(file).then(image => {
          this.categoryImage = image;
          this.categoryImageIsLoading = false;
        }).catch(err => {
          this.categoryImageIsLoading = false;
          alert(err);
        });
      }
    },
  },
  watch: {
    'editCategoryInfo'() {
      if (this.editCategoryInfo) {
        this.categoryName = this.editCategoryInfo.name;
        this.categoryDescription = this.editCategoryInfo.description;
        this.categoryImage = this.editCategoryInfo.image;
      }
    },
    'visible'() {
      if (!this.visible) {
        this.categoryName = '';
        this.categoryDescription = '';
        this.categoryImage = '';
        this.categorySaveError = '';
        this.categoryImageIsLoading = false;
      }
    },
  },
  data() {
    return {
      categoryName: '',
      categoryDescription: '',
      categorySaveError: '',
      categoryImageIsLoading: false,
      categoryImage: '',

    };
  },
}
</script>
<style lang="sass">
.create-category-modal
  input[type="file"]
    position: absolute
    opacity: 0
    left: -1000px !important

  .desc
    white-space: pre-wrap

  .choose-template
    .fa-images
      font-size: 36px
      color: #b4bfd4
      height: 50px
      margin: 10px auto 5px

    &.choose-template-hover
      &:hover
        .fa-images
          color: #0d70e3

  .choose-template-image-exist
    .inner-text
      display: none

    &:hover
      border: solid 1px #b4bfd4

      .inner-text
        display: block
        background-color: rgba(53, 64, 82, 0.7)
        position: absolute
        left: 0
        right: 0
        top: 0
        bottom: 0
        color: #ffffff

      span
        opacity: 1

      .fa-images
        color: #ffffff !important

  .preview-msg
    position: relative

    .list-mode-item
      width: 397px

      .l-m-thumbnail
        border-radius: 0

        img
          width: 100.5%

  .spinner-wrap
    display: none

  .choose-template-loading
    .spinner-wrap
      display: block
      text-align: center
      position: absolute
      left: 0
      right: 0
      top: 0
      bottom: 0
      padding-top: 50px
      background-color: rgba(255, 255, 255, 0.7)
      color: #677788
</style>

